export default __webpack_public_path__ + "static/media/logo_iryo.c345eee5.svg";